/* 🤖 this file was generated by svg-to-ts */
export const kzIconsMoodAdd: {
  name: 'mood_add';
  data: string;
} = {
  name: 'mood_add',
  data: `<svg viewBox="0 0 1000 1000" xml:space="preserve" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5"><circle cx="350" cy="650" r="300" fill="none" stroke="currentColor" stroke-width="50px"/><circle cx="250.308" cy="574.699" r="32.609"/><circle cx="444.127" cy="574.699" r="32.609"/><path d="M223.134 722.682c96.818 84.788 180.596 76.292 254.714-1.31M647.841 289.157h253.012M774.347 415.663V162.651" fill="none" stroke="currentColor" stroke-width="50px"/></svg>`
};
